import Axios from '../axios';
import appConfig from '../../../app.config';
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next'
import { logError } from '../../../shared';

async function getPinUrlService(cardId: number, t: TFunction) {
        const response = await Axios.get(
            `${appConfig.customerDataBaseUrl}/api/creditcard/pin/url?cardId=${cardId}&iMSGetPinCountryType=${appConfig.country}`,
            await getHeadersWithJwtToken()
        ).then((data) => {
            if (data.status === 200) {
                return data;
            }
            throw new Error(t('ErrorMsg'))
        }).catch((err) => {
            logError(err)
            throw new Error(t('ErrorMsg'))
        })
        return response;
}
export default getPinUrlService;